<div class="outside-background">

  <div class="modal">
    <nav>
      <h3>{{modalTitle}}</h3>
      <div class="close-button" (click)="onClose()">
        <i class="fa-solid fa-close"></i>
      </div>
    </nav>

    <section class="modal-content">
      <ng-container *ngTemplateOutlet="modalContent;"></ng-container>
    </section>

    <section>
      <button>
        <i class="fa-solid fa-discard"></i>
        Discard
      </button>

      <button>
        <i class="fa-solid fa-check"></i>
        Apply
      </button>
    </section>
  </div>

</div>